<template>
  <v-layout v-if="layout.column">
    <v-layout v-if="flip" align-center justify-center fill-height v-bind="layout">
      <v-row align="center" justify="center" no-gutters class="mt-0">
        <v-tooltip location="top center" origin="auto">
          <template #activator="{ props: activatorProps }">
            <v-col cols="12" v-bind="activatorProps" text-xs-center class="ma-auto font-weight-bold">
              <v-label>{{ currentFlowDisplay }}</v-label>
            </v-col>
            <v-col cols="12" v-bind="activatorProps">
              <img v-show="showImage" :src="imageSource" :style="imageStyle" class="interconnector-image mt-2" alt="" />
            </v-col>
          </template>
          <span class="font-weight-bold">{{ name }}</span
          ><br />
          <span
            >Flow: {{ currentFlowDisplay }}
            <v-icon v-if="current.direction === 'east'" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.direction === 'west'" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Previous: {{ previousFlowDisplay }}
            <v-icon v-if="previous.direction === 'east'" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="previous.direction === 'west'" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Export limit: {{ exportLimitDisplay }}
            <v-icon v-if="current.exportLimit && current.exportLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.exportLimit && current.exportLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Import limit: {{ importLimitDisplay }}
            <v-icon v-if="current.importLimit && current.importLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.importLimit && current.importLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span>Flow limited? {{ isCappedDisplay }}</span>
        </v-tooltip>
      </v-row>
    </v-layout>
    <v-layout v-else align-center justify-center fill-height v-bind="layout">
      <v-row align="center" justify="center" no-gutters class="pa-0 ma-0">
        <v-tooltip location="bottom center" origin="auto">
          <template #activator="{ props: activatorProps }">
            <v-col cols="12" v-bind="activatorProps">
              <img v-show="showImage" :src="imageSource" :style="imageStyle" class="interconnector-image mt-2" />
            </v-col>
            <v-col cols="12" v-bind="activatorProps" text-xs-center class="ma-auto font-weight-bold">
              <v-label>{{ currentFlowDisplay }}</v-label>
            </v-col>
          </template>
          <span class="font-weight-bold">{{ name }}</span
          ><br />
          <span
            >Flow: {{ currentFlowDisplay }}
            <v-icon v-if="current.direction === 'east'" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.direction === 'west'" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Previous: {{ previousFlowDisplay }}
            <v-icon v-if="previous.direction === 'east'" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="previous.direction === 'west'" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Export limit: {{ exportLimitDisplay }}
            <v-icon v-if="current.exportLimit && current.exportLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.exportLimit && current.exportLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span
            >Import limit: {{ importLimitDisplay }}
            <v-icon v-if="current.importLimit && current.importLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-right-thin" />
            <v-icon v-if="current.importLimit && current.importLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-left-thin" /> </span
          ><br />
          <span>Flow limited? {{ isCappedDisplay }}</span>
        </v-tooltip>
      </v-row>
    </v-layout>
  </v-layout>

  <v-layout v-else>
    <v-layout v-if="flip" align-center justify-center fill-height v-bind="layout">
      <v-tooltip location="bottom center" origin="auto">
        <template #activator="{ props: activatorProps }">
          <v-col v-bind="activatorProps" text-xs-center class="ma-auto font-weight-bold">
            <v-label>{{ currentFlowDisplay }}</v-label>
          </v-col>
          <v-col v-bind="activatorProps">
            <img v-show="showImage" :src="imageSource" :style="imageStyle" class="interconnector-image mt-2" />
          </v-col>
        </template>
        <span class="font-weight-bold">{{ name }}</span
        ><br />
        <span
          >Flow: {{ currentFlowDisplay }}
          <v-icon v-if="current.direction === 'north'" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.direction === 'south'" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Previous: {{ previousFlowDisplay }}
          <v-icon v-if="previous.direction === 'north'" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="previous.direction === 'south'" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Export limit: {{ exportLimitDisplay }}
          <v-icon v-if="current.exportLimit && current.exportLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.exportLimit && current.exportLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Import limit: {{ importLimitDisplay }}
          <v-icon v-if="current.importLimit && current.importLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.importLimit && current.importLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span>Flow limited? {{ isCappedDisplay }}</span>
      </v-tooltip>
    </v-layout>
    <v-layout v-else align-center justify-center fill-height v-bind="layout">
      <v-tooltip location="bottom center" origin="auto">
        <template #activator="{ props: activatorProps }">
          <v-col v-bind="activatorProps">
            <img v-show="showImage" :src="imageSource" :style="imageStyle" class="interconnector-image mt-2" />
          </v-col>
          <v-col v-bind="activatorProps" text-xs-center class="ma-auto font-weight-bold">
            <v-label>{{ currentFlowDisplay }}</v-label>
          </v-col>
        </template>
        <span class="font-weight-bold">{{ name }}</span
        ><br />
        <span
          >Flow: {{ currentFlowDisplay }}
          <v-icon v-if="current.direction === 'north'" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.direction === 'south'" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Previous: {{ previousFlowDisplay }}
          <v-icon v-if="previous.direction === 'north'" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="previous.direction === 'south'" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Export limit: {{ exportLimitDisplay }}
          <v-icon v-if="current.exportLimit && current.exportLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.exportLimit && current.exportLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span
          >Import limit: {{ importLimitDisplay }}
          <v-icon v-if="current.importLimit && current.importLimit > 0" class="ml-1 mb-1" icon="mdi-arrow-up-thin" />
          <v-icon v-if="current.importLimit && current.importLimit < 0" class="ml-1 mb-1" icon="mdi-arrow-down-thin" /> </span
        ><br />
        <span>Flow limited? {{ isCappedDisplay }}</span>
      </v-tooltip>
    </v-layout>
  </v-layout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { InterconnectorSnapshot } from '@/repositories';
import arrowEast from '../images/arrow-east.png';
import arrowEastCapped from '../images/arrow-east-capped.png';
import arrowNorth from '../images/arrow-north.png';
import arrowNorthCapped from '../images/arrow-north-capped.png';
import arrowSouth from '../images/arrow-south.png';
import arrowSouthCapped from '../images/arrow-south-capped.png';
import arrowWest from '../images/arrow-west.png';
import arrowWestCapped from '../images/arrow-west-capped.png';
import notFlowing from '../images/not-flowing.png';

const images: { [key: string]: string } = {
  east: arrowEast,
  'east-capped': arrowEastCapped,
  north: arrowNorth,
  'north-capped': arrowNorthCapped,
  south: arrowSouth,
  'south-capped': arrowSouthCapped,
  west: arrowWest,
  'west-capped': arrowWestCapped,
  'not-flowing': notFlowing
};

const props = defineProps({
  name: { type: String, default: '' },
  flip: Boolean,
  vertical: Boolean,
  current: { type: InterconnectorSnapshot, default: () => new InterconnectorSnapshot() },
  previous: { type: InterconnectorSnapshot, default: () => new InterconnectorSnapshot() },
  rotation: { type: Number, default: undefined }
});

const layout = computed(() => ({
  row: !props.vertical,
  column: props.vertical
}));

const showImage = computed(() => props.current?.direction !== undefined);

const imageSource = computed(() => {
  if (!showImage.value) return undefined;
  return props.current?.direction === 'not-flowing' ? images['not-flowing'] : images[`${props.current?.direction}${props.current?.isCapped ? '-capped' : ''}`];
});

const imageStyle = computed(() => (props.rotation !== undefined ? { transform: `rotate(${props.rotation}deg)` } : undefined));

const exportLimitDisplay = computed(() => (props.current?.exportLimit !== undefined ? Math.abs(props.current.exportLimit) : '--'));
const importLimitDisplay = computed(() => (props.current?.importLimit !== undefined ? Math.abs(props.current.importLimit) : '--'));

const currentFlowDisplay = computed(() => props.current?.flow ?? '--');
const previousFlowDisplay = computed(() => props.previous?.flow ?? '--');
const isCappedDisplay = computed(() => props.current?.isCapped ?? '--');
</script>

<style scoped>
img.interconnector-image {
  height: 12pt;
}

label {
  font-size: 10pt;
  opacity: 1;
}
</style>
